module.exports = __webpack_public_path__ + "static/media/ipsAvatar.72269ea3.png";